import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

enum CacheKey {
  SmsQuota = 'SmsQuota',
}

export const useGetSmsQuotaQuery = () => {
  const { getSmsQuota } = useServicesContext();
  return useQuery({
    queryKey: [CacheKey.SmsQuota],
    queryFn: getSmsQuota,
  });
};
